import "../styles/NavBar.css"
import 'bootstrap/dist/js/bootstrap.bundle.min'; 

function NavBar() {
    const scrollToSection = (id) => {
        const targetSection = document.getElementById(id);
        const offset = 100; // Adjust this value to move the section lower if needed
    
        window.scrollTo({
          top: targetSection.offsetTop - offset, // Apply the offset
          behavior: 'smooth'
        });
      };




    return(
        <nav className="navbar navbar-expand-lg navbar-dark bg-black fixed-top">
            <div className="container">
                {/* <a className="navbar-brand text-white" href="#">LOGO</a> */}
                <img src="./logo-inverted.png" width="35" height="35"></img>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item"><a className="nav-link text-white" onClick={() => scrollToSection('intro')}>Home</a></li>
                        <li className="nav-item"><a className="nav-link text-white" onClick={() => scrollToSection('about')}>About</a></li>
                        <li className="nav-item"><a className="nav-link text-white" onClick={() => scrollToSection('timeline')}>Experience</a></li>
                        <li className="nav-item"><a className="nav-link text-white" onClick={() => scrollToSection('portfolio')}>Portfolio</a></li>
                        {/* <li className="nav-item"><a className="nav-link text-white" onClick={() => scrollToSection('blog')}>Blog</a></li> */}
                    </ul>
                </div>
            </div>
        </nav>
    )

}

export default NavBar